var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVideoActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 46,
    viewBox: "0 0 67 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.835%",
    y1: "31.836%",
    x2: "95.721%",
    y2: "69.32%",
    id: "o3hwkeivaa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: ".073%",
    x2: "97.491%",
    y2: "99.927%",
    id: "eif9mfvj8b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACF00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A100",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.89 4.165a5.523 5.523 0 0 0-5.754.301l-10.68 7.193V5.94C39.454 2.661 36.807.004 33.539 0H5.918C2.652.004.005 2.661 0 5.94v27.72c.004 3.279 2.651 5.936 5.919 5.94h27.62c3.266-.004 5.914-2.661 5.918-5.94v-5.72l10.68 7.194a5.483 5.483 0 0 0 5.753.3 6.433 6.433 0 0 0 3.295-5.741V9.908a6.433 6.433 0 0 0-3.295-5.743zM35.511 33.66a1.979 1.979 0 0 1-1.973 1.98H5.918a1.979 1.979 0 0 1-1.972-1.98V5.94a1.979 1.979 0 0 1 1.973-1.98h27.62a1.979 1.979 0 0 1 1.972 1.98v27.72zm19.728-3.968a2.484 2.484 0 0 1-1.206 2.25 1.567 1.567 0 0 1-1.696-.096l-12.88-8.674v-6.744l12.877-8.673a1.594 1.594 0 0 1 1.7-.096 2.484 2.484 0 0 1 1.205 2.249v19.784z",
    transform: "translate(0 6.4)",
    fill: "url(#o3hwkeivaa)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.613-1c.855 0 1.63.346 2.19.906s.907 1.334.907 2.19l-.001 3.19h3.194c.855 0 1.63.346 2.19.906S66 7.526 66 8.381s-.347 1.629-.907 2.189-1.335.906-2.19.906H59.71v3.19c0 .855-.346 1.63-.907 2.19-.56.56-1.334.906-2.19.906-.854 0-1.628-.346-2.189-.906a3.085 3.085 0 0 1-.907-2.19v-3.19h-3.193c-.856 0-1.63-.346-2.19-.906a3.085 3.085 0 0 1-.907-2.189c0-.855.346-1.629.907-2.189a3.088 3.088 0 0 1 2.19-.906h3.193v-3.19c0-.856.347-1.63.907-2.19A3.088 3.088 0 0 1 56.613-1z",
    stroke: "#000",
    strokeWidth: 2,
    fill: "url(#eif9mfvj8b)",
    transform: "translate(0 2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoActive);
export default __webpack_public_path__ + "static/media/ic_video_active.dc7ec48df123b13518507330239f3ef6.svg";
export { ForwardRef as ReactComponent };